<template>
  <div class="sectionImage" :class="handleClass">
    <b-container class="summary">
      <b-row class="header">
        <b-col>
          {{text}}
        </b-col>
      </b-row>
      <b-row class="align-self-end">
        <b-col sm="12" md="6" offset-md="3">
          {{summary}}
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'sectionImage',
  props: {
    section: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    summary: {
      type: String,
      default: ''
    }
  },
  computed: {
    handleClass () {
      switch (this.section) {
        case 'news':
          return 'news'
        case 'services':
          return 'services'
        case 'General Terms and Conditions':
          return 'generalTerms'
        case 'contact':
          return 'contact'
        case 'about':
          return 'about'
        case 'products':
          return 'products'
        case 'analysts':
          return 'analysts'
        case 'videos':
          return 'videos'
        default:
          return 'services'
      }
    }
  }
}

</script>

<style scoped>

.sectionImage {
  width: 100%;
  height: 375px;
  text-align: center;
  color: #ffffff;
}

.header {
  padding-top: 150px;
  font-weight: 500;
  font-size: 44px;
  text-transform: uppercase;
}

@media only screen and (max-width: 600px) {
  .sectionImage {
      height: 450px;
  }
}

@media only screen and (max-width: 1000px) {
  .header {
      padding-top: 100px;
  }
}

.summary {
  color: #ffffff;
  font-weight: 500;
  font-size: 17px;
  margin-bottom: 20px;
}

.news {
  background: url('../assets/News.png') no-repeat 50% 50%;
}

.services {
  background: url('../assets/Services.jpg') no-repeat 50% 70%;
}

.generalTerms {
  background: url('../assets/general.jpg') no-repeat 50% 50%;
}

.contact {
  background: url('../assets/Contact.jpg') no-repeat 50% 50%;
  background-size: cover;
}

.about {
  background: url('../assets/About.jpg') no-repeat 50% 50%;
  background-size: cover;
}

.products {
  background: url('../assets/Products.jpg') no-repeat 50% 60%;
  background-size: cover;
}

.analysts {
  background: url('../assets/Analysts.jpg') no-repeat 50% 50%;
  background-size: cover;
}

.videos {
  background: url('../assets/Videos.jpg') no-repeat 50% 50%;
  background-size: cover;
}

</style>



// WEBPACK FOOTER //
// src/components/SectionImage.vue